<template lang="pug">
div
    template(v-if="$store.state.queryGroupName == 'all'")
        Card
            div(style="text-align: center")
                h3 Please choose a group to manage.
    template(v-else)
        Card.a8-page-description-card
            Row(type="flex" align="middle" justify="space-between")
                Col
                    h2 {{$t("subscription.pageTitleText") }}
        Card(bordered style="margin-bottom: 20px")
            Tabs(type="card")
                TabPane(label="History")
                    Form(:model="historyFrom" :label-width="80" style="min-width: 200px")
                        FormItem(label="Date")
                            DatePicker(
                            v-model="historyFrom.customTimeRange"
                            type="daterange"
                            :placeholder="$t('main.selectTimePlaceholder')"
                            style="width: 200px;"
                            )
                            Button(type="primary" @click="getHistoryData") {{'Search'}}
                            Button.searchChartBtn(type="primary" icon="md-download" style="margin-left: 5px;" 
                                @click="exportPdf" id="exportPdf" 
                                v-if="isShowExportBtn") {{$t('netflowAnalyze.exportPdf')}}
                        FormItem(label="export field")
                            Checkbox(:indeterminate="isCheckAll" v-model="chooseAll" @on-change="handleCheckAll") {{ '全選' }}
                            br
                            Checkbox(v-model="item.isShow" v-for="item in exportFields" :key="item.key" :label="item.key" @on-change="handleSingleCheckboxChange(item.key)") {{ item.key }}
                        div#pdfDom
                            Row(type="flex" align="middle" justify="center" v-show="isShowExportTable")
                                Col
                                    h1(style="height: 80px") {{$t("subscription.pageTitleText") }}
                            FormItem
                                Row(type="flex" align="middle" justify="space-between" v-show="isShowExportTable")
                                    Col(span="16" push="8")
                                        h3 {{ 'Group:'+$store.state.queryGroupName }}
                                    Col(span="8" pull="16")
                                        h3 {{ 'Range:'+rangeDate }}
                                Card.dashBoardCard
                                    line-chart(
                                        ref="lineChart"
                                        :chart-data="chartData.datacollection"
                                        :options="chartData.options"
                                        :width="600"
                                        :height="340"
                                    )
                            Table(v-show="isShowExportTable" :columns="exportTableColumns" :data="exportTableData")
                        FormItem
                            Table(stripe :columns="columns" :data="data")
                TabPane(label="Edit Resource Usage")
                    div(v-for="data in category")
                        SubscriptionContent(:category="data.value" :categoryName="data.name" :groupName="$store.state.queryGroupName" :usage="groupData[data.usedKey]" :subscription="groupData[data.subscriptionKey]!==undefined ? groupData[data.subscriptionKey] : groupData[data.maxCountKey]" :maxCountKey="groupData[data.maxCountKey]!==undefined ? groupData[data.maxCountKey]:$store.getters.resourceLimits[data.maxCountKey]" @updateSuccess="getData")
    Spin(size="large" fix v-if="spinShow")
</template>
<script>
import { getEsData } from "@/api/esdata";
import { _groupUsage } from "@/api/system.js";
import SubscriptionContent from "@/components/subscriptionContent";
import resourceUsageHistory from "@/components/resourceUsageHistory";
import LineChart from "@/components/lineChart.js";
import moment from "moment";
const firstDay = moment().startOf("month").format("YYYY-MM-DD");
const nowDay = moment().format("YYYY-MM-DD");
import Vue from "vue";
Vue.component("resourceUsageHistory", resourceUsageHistory);
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export default {
    components: {
        SubscriptionContent,
        LineChart,
    },
    data() {
        return {
            category: [
                {
                    name: "FQDNConfig",
                    value: "fqdnConfigs",
                    usedKey: "createdFQDNConfigCount",
                    maxCountKey: "maxFQDNConfigCount",
                    subscriptionKey: "fqdnConfigsSubscription",
                    id: "AppProfile",
                },
                {
                    name: "FQDN",
                    value: "fqdns",
                    usedKey: "createdServerNameCount",
                    maxCountKey: "maxServerNameCount",
                    subscriptionKey: "fqdnsSubscription",
                    id: "FQDN",
                },
                {
                    name: "Waf Rule",
                    value: "wafRules",
                    usedKey: "createdWafRuleCount",
                    maxCountKey: "maxWafRuleCount",
                    subscriptionKey: "wafRulesSubscription",
                    id: "WafRule",
                },
                {
                    name: "Origin Policy",
                    value: "originPolicies",
                    usedKey: "createdOriginPolicyCount",
                    maxCountKey: "maxOriginPolicyCount",
                    subscriptionKey: "originPoliciesSubscription",
                    id: "OriginPolicy",
                },
                {
                    name: "HTML Page",
                    value: "htmlPages",
                    usedKey: "createdHtmlPageCount",
                    maxCountKey: "maxHtmlPageCount",
                    subscriptionKey: "htmlPagesSubscription",
                    id: "HTMLPage",
                },
                {
                    name: "Cert",
                    value: "certs",
                    usedKey: "createdCertPemCount",
                    maxCountKey: "groupMaxCertManageCount",
                    subscriptionKey: "certsSubscription",
                    id: "Cert_Sectigo",
                },
                {
                    name: "Alert Rule",
                    value: "alertRules",
                    usedKey: "createdAlertRuleCount",
                    maxCountKey: "maxAlertRuleCount",
                    subscriptionKey: "alertRulesSubscription",
                },
                {
                    name: "Site",
                    value: "servicegroups",
                    usedKey: "createdServiceGroupCount",
                    maxCountKey: "maxServiceGroupCount",
                    subscriptionKey: "servicegroupsSubscription",
                    id: "Site",
                },
            ],
            spinShow: false,
            groupData: {
                createdAlertRuleCount: 0,
                createdAppProfileCount: 0,
                createdCertPemCount: 0,
                createdFQDNConfigCount: 0,
                createdHtmlPageCount: 0,
                createdNonProfileServerNameCount: 0,
                createdOriginPolicyCount: 0,
                createdScrollCount: 0,
                createdServerNameCount: 0,
                createdServiceGroupCount: 0,
                createdUserCount: 0,
                createdWafRuleCount: 0,
                maxAlertRuleCount: 0,
                maxAssignEdgeCount: 0,
                maxAssignSlbCount: 0,
                maxDomainListenPortCount: 0,
                maxGroupListenPortCount: 0,
                maxDomainOriginCount: 0,
                maxFQDNConfigCount: 0,
                maxHtmlPageCount: 0,
                maxOriginPolicyCount: 0,
                maxServerNameCount: 0,
                maxServiceGroupCount: 0,
                maxUserCount: 0,
                maxWafRuleCount: 0,
            },
            resourceUsages: {
                HTMLPage: {},
                Cert_Sectigo: {},
                Cert_Zerossl: {},
                AppProfile: {},
                Plan: {},
                WafRule: {},
                FQDN: {},
                SLB: {},
                EDGE: {},
                User: {},
                Site: {},
                OriginPolicy: {},
            },
            historyFrom: {
                groupName: this.$store.state.queryGroupName,
                customTimeRange: [firstDay, nowDay],
            },
            columns: [
                {
                    type: "expand",
                    width: 50,
                    render: (h, { row: { item, qty, data } }) => {
                        const Tabs = h("resourceUsageHistory", {
                            props: {
                                value: data,
                            },
                        });

                        return h("div", [Tabs]);
                    },
                },
                {
                    title: "Item",
                    key: "item",
                    align: "center",
                },
                {
                    title: "Qty",
                    key: "qty",
                    align: "center",
                },
            ],
            data: [],
            chartData: {
                datacollection: {},
                options: {},
            },
            isShowExportTable: false,
            exportFields: [],
            exportTableData: [],
            chooseAll: true,
        };
    },
    computed: {
        searchOptions() {
            var options = {
                isFuzzySearch: true,
                esIndex: "rcm-edgegroup",
                from: 0,
                sort: [{ modifiedDate: { order: "desc" } }],
                filters: [
                    {
                        key: "groupName",
                        type: "string",
                        value: this.$store.state.queryGroupName == "all" ? "*" : this.$store.state.queryGroupName,
                    },
                ],
                searchView: "GroupSubscription",
            };
            return options;
        },
        isShowExportBtn() {
            return this.$store.state.queryGroupName !== "all" && this.exportFields.filter((e) => e.isShow).length > 0;
        },
        // 匯出選擇日期
        rangeDate() {
            return `${moment(this.historyFrom.customTimeRange[0]).format("YYYY-MM-DD")}~${moment(
                this.historyFrom.customTimeRange[1]
            ).format("YYYY-MM-DD")}`;
        },
        // 判斷是否勾取全部
        isCheckAll() {
            const exportFieldsData = this.exportFields.filter((e) => e.isShow);
            return exportFieldsData.length === this.exportFields.length
                ? false
                : exportFieldsData.length > 0
                ? true
                : false;
        },
        // 設定匯出表格的表頭
        exportTableColumns() {
            let tableColumns = [
                {
                    align: "center",
                    title: "date",
                    key: "date",
                },
            ];
            this.exportFields
                .filter((e) => e.isShow)
                .forEach((fieldItem) => {
                    tableColumns.push({
                        align: "center",
                        title: fieldItem.key,
                        key: fieldItem.key,
                    });
                });
            return tableColumns;
        },
    },
    methods: {
        async getData() {
            this.spinShow = true;
            if (this.$store.state.queryGroupName != "all") {
                let result = await getEsData(this.searchOptions);
                if (result.data.success) {
                    Object.assign(this.groupData, result.data.mapData[0]);
                } else {
                    this.$Message.error("Get Resource Usage error...");
                }
            }
            this.spinShow = false;
        },
        async getHistoryData() {
            this.spinShow = true;
            let getGroupUsage = await _groupUsage(this.historyFrom);
            if (getGroupUsage.data.success) {
                this.resourceUsages = getGroupUsage.data.data;
                const keys = Object.keys(this.resourceUsages);
                this.data = keys.map((key) => {
                    let qty = 0;
                    const childKeys = Object.keys(this.resourceUsages[key]);
                    childKeys.forEach((childKey) => {
                        qty += this.resourceUsages[key][childKey].recordUsageCount;
                    });
                    return {
                        item: key,
                        qty,
                        data: this.resourceUsages[key],
                    };
                });
                // 整理資源用量折線圖所需的資料
                // 折線圖橫軸的日期（選取到的日期範圍）
                let labels = [];
                let startDate = moment(this.historyFrom.customTimeRange[0]);
                let endDate = moment(this.historyFrom.customTimeRange[1]);
                while (startDate.isBefore(endDate)) {
                    labels.push(startDate.format("YYYY-MM-DD"));
                    startDate.add(1, "day");
                }

                // 折線圖的線條配色
                const colorScheme = [
                    "rgba(255, 53, 94, 1)",
                    "rgba(253, 91, 120, 1)",
                    "rgba(255, 96, 55, 1)",
                    "rgba(255, 153, 102, 1)",
                    "rgba(255, 153, 51, 1)",
                    "rgba(255, 204, 51, 1)",
                    "rgba(255, 255, 102, 1)",
                    "rgba(204, 255, 0, 1)",
                    "rgba(102, 255, 102, 1)",
                    "rgba(170, 240, 209, 1)",
                    "rgba(22, 208, 203, 1)",
                    "rgba(80, 191, 230, 1)",
                    "rgba(156, 39, 176, 1)",
                    "rgba(238, 52, 210, 1)",
                    "rgba(255, 0, 204, 1)",
                ];
                // 折線圖縱軸的資料（每個日期的每種資源用量）
                let datasets = [];
                Object.keys(this.resourceUsages).forEach((resource, index) => {
                    let itemInDatasets = {
                        data: Object.values(this.resourceUsages[resource]).map((item) => item.recordUsageCount),
                        label: resource,
                        borderColor: colorScheme[index],
                        fill: false,
                        lineTension: 0,
                        pointBackgroundColor: colorScheme[index],
                        pointBorderWidth: 3,
                        pointHoverBackgroundColor: "white",
                        pointHoverBorderColor: "white",
                        pointHoverBorderWidth: 5,
                        pointHoverRadius: 1,
                        pointRadius: 0,
                    };
                    datasets.push(itemInDatasets);
                });
                // 將整理好的縱軸和橫軸資料放入 chartData
                this.chartData = {
                    datacollection: {
                        labels: labels,
                        datasets: datasets,
                    },
                    options: {
                        title: {
                            display: true,
                            text: this.$t("subscription.resourceUsageLineChart"),
                        },
                        legend: {
                            position: "right",
                            align: "start",
                        },
                        scales: {
                            yAxes: [
                                {
                                    ticks: {
                                        callback: function (value) {
                                            return value + " 個";
                                        },
                                    },
                                },
                            ],
                        },
                    },
                };
            } else {
                this.$Message.error("Get History error...");
            }
            await this.setExportTableData();
            this.spinShow = false;
        },
        // 依據搜尋結果，設定匯出表格資料
        setExportTableData() {
            // 抓取搜尋回來的物件
            const itemKeys = Object.keys(this.resourceUsages);
            // 預設全選
            this.chooseAll = true;
            this.exportFields = itemKeys.map((key) => {
                return {
                    key,
                    isShow: true,
                };
            });
            // 將物件所有的日期抓出來並去除重複
            let tableColumnsDate = [];
            itemKeys.forEach((itemKey) => {
                const date = Object.keys(this.resourceUsages[itemKey]);
                tableColumnsDate = [...new Set(tableColumnsDate.concat(date))];
            });

            // 依據日期建構物件使用量
            let tableData = [];
            tableColumnsDate.forEach((date) => {
                let data = { date };
                itemKeys.forEach((itemKey) => {
                    data[itemKey] = this.resourceUsages[itemKey][date].recordUsageCount;
                });
                tableData.push(data);
            });

            // 計算total&average的數量
            let total = { date: "total" };
            let average = { date: "average" };
            itemKeys.forEach((itemKey) => {
                const items = tableData.map((e) => e[itemKey]);
                const itemTotal = items.reduce((sum, num) => sum + num, 0);
                total[itemKey] = itemTotal;
                average[itemKey] = Number.parseFloat(itemTotal / items.length).toFixed(2);
            });
            tableData.push(total);
            tableData.push(average);

            this.exportTableData = tableData;
        },
        // 設定全選項目
        handleCheckAll() {
            this.exportFields = this.exportFields.map((e) => {
                if (this.chooseAll !== e.isShow) {
                    this.handleSingleCheckboxChange(e.key);
                }
                return {
                    key: e.key,
                    isShow: this.chooseAll,
                };
            });
        },
        // 依據物件將報表顯示影藏
        handleSingleCheckboxChange(item) {
            const keys = Object.keys(this.resourceUsages);
            // 抓取物件的位置
            const index = keys.indexOf(item);
            // 抓取報表物件
            const chartInstance = this.$refs.lineChart.$data._chart;
            // 依據index位置抓取該物件
            const meta = chartInstance.getDatasetMeta(index);
            // 切換隱藏狀態
            meta.hidden = meta.hidden === null ? true : !meta.hidden;
            // 依據請求進行表格進行欄位顯示與否
            this.exportFields = this.exportFields.map((e) => {
                if (e.key === item) {
                    e.isShow = !meta.hidden;
                }
                return e;
            });
            // 更新圖表
            chartInstance.update();
        },
        // 匯出報表
        exportPdf() {
            this.spinShow = true;
            this.isShowExportTable = true;
            const vm = this;
            setTimeout(() => {
                // 抓取要匯出的物件
                const element = document.querySelector("#pdfDom");
                // 目前選擇的群組
                const groupName = this.$store.state.queryGroupName;
                // 元素的寬
                const w = element.offsetWidth;
                // 元素的長
                const h = element.offsetHeight;
                // 元素頂部
                const offsetTop = element.offsetTop;
                // 元素左側
                const offsetLeft = element.offsetLeft;
                // 創建一個 <canvas> 元素，用來存放要轉換的圖像。
                const canvas = document.createElement("canvas");
                // 用於存儲左右邊距的誤差
                let abs = 0;
                // 瀏覽器視口（不包含滾動條）的寬度
                const win_i = document.documentElement.clientWidth || document.body.clientWidth;
                // 是窗口的整體寬度（包含滾動條）
                const win_o = window.innerWidth;
                // 如果 win_o 大於 win_i，則計算滾動條的寬度，並將其一半存入 abs，這是為了確保截圖時內容對齊
                if (win_o > win_i) {
                    abs = (win_o - win_i) / 2;
                }
                // 設定 canvas 的寬度和高度為兩倍大小，以確保輸出圖像的清晰度
                canvas.width = w * 2;
                canvas.height = h * 2;
                // 獲取 canvas 的 2D 繪圖上下文
                const context = canvas.getContext("2d");
                // 將 canvas 的繪製內容放大 2 倍，以提升解析度
                context.scale(2, 2);
                // 移動畫布，使其對準要截取的元素
                context.translate(-offsetLeft - abs, -offsetTop);
                // 使用 html2canvas 將 element（要轉換的 HTML 元素）渲染為 canvas
                html2canvas(element, groupName).then(function (canvas) {
                    // 取得 canvas 的寬度
                    const contentWidth = canvas.width;
                    // 取得 canvas 的高度
                    const contentHeight = canvas.height;
                    // 計算 PDF 的單頁高度，592.28 × 841.89 是 A4 紙張的尺寸（以 pt 為單位）
                    const pageHeight = (contentWidth / 592.28) * 841.89;
                    // 表示還未導出的內容高度
                    let leftHeight = contentHeight;
                    // 用於跟蹤當前圖片應該放置的位置
                    let position = 0;
                    // 設定圖片寬度為 592.28pt（A4 寬度），並按比例計算 imgHeight
                    const imgWidth = 592.28;
                    const imgHeight = (592.28 / contentWidth) * contentHeight;
                    // 將 canvas 轉換為 JPEG 格式的 Base64 數據
                    const pageData = canvas.toDataURL("image/jpeg", 1.0);
                    // 創建一個 jsPDF 對象，設置紙張大小為 A4（以 pt 為單位）
                    const pdf = new jsPDF("", "pt", "a4");
                    // 如果 leftHeight 小於 pageHeight，說明內容可以放入一頁，直接添加圖片
                    if (leftHeight < pageHeight) {
                        pdf.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
                    }
                    // 如果 leftHeight 大於 pageHeight，則需要分頁
                    else {
                        while (leftHeight > 0) {
                            pdf.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
                            leftHeight -= pageHeight;
                            position -= 841.89;
                            if (leftHeight > 0) {
                                pdf.addPage();
                            }
                        }
                    }
                    // 直接儲存
                    pdf.save(`history-${groupName}.pdf`);
                    vm.isShowExportTable = false;
                    vm.spinShow = false;
                });
            }, 100);
        },
    },
    async mounted() {
        await this.getData();
        await this.getHistoryData();
    },
};
</script>
<style lang="less">
.dashBoardCard {
    margin-top: 20px;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/view/Subscription.vue